import Vue from 'vue';
// import Vue from "vue/dist/vue.common.js";
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import {
  messages
} from './components/common/i18n';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/element-variables.scss'
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
import api from './utils/api';
import echarts from 'echarts';
import 'default-passive-events';
import Print from './utils/print.js';
import downloadApi from'./utils/download.js';//下载打印
import throttleApi from'./utils/throttle.js';//节流
Vue.prototype.downloadApi = downloadApi;
Vue.prototype.throttleApi = throttleApi;
Vue.use(Print);
// 小程序截长图
import html2canvas from 'html2canvas';
Vue.prototype.$html2canvas = html2canvas;
// import animated from 'animate.css';
// Vue.use(animated);
Vue.prototype.$echarts = echarts
Vue.prototype.api = api;
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(ElementUI, {
  size: 'small'
});
const i18n = new VueI18n({
  locale: 'zh',
  messages
});
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  if (to.path == '/login') {
    if (localStorage.getItem('chooseSyf')) {
      localStorage.removeItem('chooseSyf');
    }
    if (sessionStorage.getItem('user')) {
      sessionStorage.removeItem('user');
    }
  }
  if(to.path == '/authorizeHs'){
    document.title = '关联授权';
  }
  next();

});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');